// JSLint directives
/* global window, document, jQuery, App, PubSub, configurations */
/* eslint no-magic-numbers: ["error", { "ignore": [0, 1, 2, 3, -1, -2, -3, -4, -5, -6, -7 ] }] */
(function ($, App, namespace, doc, PubSub, conf) {

    'use strict';

    var $form = null,
        modal = new App.Modal({
            isSmall: true
        }),
        requestValidator = null,
        FormExt = null,
        RequestStorage = namespace.request.RequestStorage,
        RequestFormExtended = namespace.request.ExtendedForm,
        ABOGADOS_PROJECT_IDS = [17, 91, 94, 95, 101, 107, 110, 112];
    ;

    /**
     * ---------------------------------------------
     * Global functions.
     *
     * This functions are used on other files.
     * Needs to be refactored using Reveal pattern.
     * ---------------------------------------------
     * ---------------------------------------------
     */

    window.isAppointment = false;

    /**
     * Scroll is needed to ensure the selected element is visible, it uses
     * the element's father in order to ensure caption and error messages are
     * also visible.
     *
     * @param {object} element Object to be scrolled
     */
    function scrollToElement(element) {
        if (typeof element === 'object') {
            element[0].parentNode.scrollIntoView();
        } else if (typeof element === 'string') {
            $(element)[0].parentNode.scrollIntoView();
        }
    }

    /**
     * Opens the request Form in a layer. First step.
     * This is a global function.
     *
     * @param {Number} comId  Company id (Mandatory).
     * @param {Number} headId Headquarter id (Optional).
     * @param {Number} sevId  Service id (Optional).
     * @param {object} appointmentParams
     * @param {Number} off
     * @param {boolean} isOnlineTherapyCardSection coming from there or not
     * @param {boolean} companyWithOnline If has online or not
     */
    window.showLayerRequestForm = function (
        comId,
        headId,
        sevId,
        appointmentParams,
        off,
        isOnlineTherapyCardSection,
        companyWithOnline
    ) {
        var hasNewID = !!(comId),
            foreignLead = false;

        App.pageVar.comId = comId || App.pageVar.comId;
        App.geoLocationManager.checkGeoIpRequest().then(function (response) {
            if (response.success && response.message === '4') {
                if (typeof companyWithOnline === 'undefined' || !companyWithOnline) {
                    App.geoLocationManager.setGeoIpLayer(response);
                    return;
                }
                foreignLead = true;
            }
            showRequestForm(hasNewID, headId, sevId, appointmentParams, off, isOnlineTherapyCardSection, foreignLead);
        });
    };

    /**
     * Need to be global function.
     * @param {Number} pop
     * @param {Number} ae2
     * @deprecated
     */
    window.onCheckPopulation = function (pop, ae2) {
        $('#pop_id').val(pop);
        $('#ae2_id').val(ae2);
        $('#pop_autocomplete_validation').val('1').change();

        // Sets company headquarter in request form
        assignHeadquarter(App.pageVar.comId, pop, ae2);
        $('#js_check_autocomplete').hide();
        $form.submit();
    };

    /**
     * Sets header in request form, depending of population autocomplete value.
     *
     * @param {Number} comId
     * @param {Number} pop Population id
     * @param {Number} ae2 Province id
     */
    function assignHeadquarter(comId, pop, ae2) {
        var randPos;

        if (typeof App.pageVar[comId] !== 'undefined') {
            if (typeof App.pageVar[comId].head_by_pop[pop] !== 'undefined') {

                if (App.pageVar[comId].head_by_pop[pop]['length'] === 0) {

                    $('#head_id').val(App.pageVar[comId].head_by_pop[pop][0]);
                } else {

                    randPos = Math.floor(Math.random() * App.pageVar[comId].head_by_pop[pop]['length']);
                    $('#head_id').val(App.pageVar[comId].head_by_pop[pop][randPos]);
                }
            } else if (typeof App.pageVar[comId].head_by_ae2[ae2] !== 'undefined') {

                if (App.pageVar[comId].head_by_ae2[ae2]['length'] === 0) {

                    $('#head_id').val(App.pageVar[comId].head_by_ae2[ae2][0]);
                } else {

                    randPos = Math.floor(Math.random() * App.pageVar[comId].head_by_ae2[ae2]['length']);
                    $('#head_id').val(App.pageVar[comId].head_by_ae2[ae2][randPos]);
                }
            } else {
                $('#head_id').val(App.pageVar[comId].headId);
            }
        }
    }

    /**
     * Gets the request form container.
     *
     * @param {boolean} isNewForm
     * @param {Number} selectedHeadId Selected headquarter id in Google map.
     * @param {Number} selectedSevId  Selected service id.
     * @param {object}  appointmentParams
     * @param {Number} off
     * @param {boolean} isOnlineTherapyCardSection coming from there or not
     * @param {boolean} foreignLead foreign lead or not
     */
    function showRequestForm(
        isNewForm,
        selectedHeadId,
        selectedSevId,
        appointmentParams,
        off,
        isOnlineTherapyCardSection,
        foreignLead
    ) {
        var parameters,
            title = window.isAppointment
                ? window.configurations.labels.MENU_APPOINTMENT_ttl
                : window.configurations.labels.COMMON_company_request_put_info_form_go,
            params = new URLSearchParams(window.location.href);

        parameters = {com: App.pageVar.comId};

        if (isNewForm) {
            $('#div_steps').remove();
        }

        if ($('#div_steps').length !== 0) {
            $('#frm-request').parent().remove();
            $('#psico_request_box').remove();
        }

        if (off) {
            parameters.off = off;
        }

        // selects the previous clicked service on the services select of the request form
        if (typeof selectedSevId !== 'undefined' && parseInt(selectedSevId) > 0) {
            parameters.sev = selectedSevId;
        }

        if (typeof isOnlineTherapyCardSection !== 'undefined') {
            parameters.isOnlineTherapyCardSection = isOnlineTherapyCardSection;
        } else {
            parameters.isOnlineTherapyCardSection = params.get('therapytype');
        }

        if (appointmentParams !== undefined) {
            $.extend(parameters, appointmentParams);
        }

        if (params.get('req_source_type') !== 'undefined') {
            parameters.sourceType = parseInt(params.get('req_source_type'));
       }

        if (params.get('service') !== 'undefined') {
            parameters.service = parseInt(params.get('service'));
       }

        modal.showLoading();

        // Assign handler
        modal.closeCallback(() => {
            window.gaTrackListRequestCloseModal(parameters.com);
        });

        $.get('/front/request/get_request_form', parameters).done(function (html) {
            window.gaTrackListRequestOpenModal(parameters.com);
            modal.insert(html, true, title)
                .then(function (modalContent) {
                    $form = $(modalContent).find('#request_form_v2');
                    initForm($form);
                    return $form;
                }).then(function($form) {
                    if (foreignLead) {
                        $form.find('[data-component="auto_complete_input"]').remove();
                        $form.find('#select_online_therapy').attr('checked', true).prop('checked', true);
                        $form.find('#deselect_online_therapy').attr('disabled', true);
                        $form.find('#deselect_online_therapy').parent().addClass('ds-out-of-country');
                    } else {
                        $form.find('[for="out_of_country"]').remove();
                        $form.find('#deselect_online_therapy').parent().removeClass('ds-out-of-country');
                    }
                });
        }).fail(function () {
            modal.remove();
        });
    }

    /**
     * Init datepicker
     *
     * @param {object} $form
     */
    function initializeDatepickers($form) {
        var appointmentDate = new Date(),
            extendedFormDate = new Date(),
            dateInput = document.querySelector('.jq_fe_type_datepicker'),
            fromDateInput = document.getElementById('js_element_datepicker_from'),
            toDateInput = document.getElementById('js_element_datepicker_to'),
            companyCardInput = document.getElementById('appointment_date'),
            daysAddition = 3,
            daysAdditionExtended = 7,
            fromDatePicker, toDatePicker;

        if (dateInput) {
            dateInput.type = 'date';
            dateInput.min = new Date().toISOString().split('T')[0];
            dateInput.removeAttribute('readonly');
        }

        if (fromDateInput && toDateInput) {

            extendedFormDate.setDate(extendedFormDate.getDate() + daysAdditionExtended);

            fromDatePicker = new window.Pikaday(
                window.App.picker.getParams(
                    fromDateInput,
                    {
                        minDate: extendedFormDate,
                        onSelect: function (selectedDate) {
                            toDatePicker.setMinDate(new Date(selectedDate));
                        }
                    })
            );
            toDatePicker = new window.Pikaday(
                window.App.picker.getParams(
                    toDateInput,
                    {
                        minDate: extendedFormDate,
                        onSelect: function (selectedDate) {
                            fromDatePicker.setMaxDate(new Date(selectedDate));
                        }
                    })
            );
        }

        // Appointment date picker.
        if (companyCardInput) {
            appointmentDate.setDate(appointmentDate.getDate() + daysAddition);

            new window.Pikaday(
                window.App.picker.getParams(
                    companyCardInput, {
                        minDate: appointmentDate,
                        disableWeekends: true
                    })
            );
        }
    }

    /**
     * Validation rules initialization
     *
     * @param {object} $form
     * @returns {*|jQuery|string|boolean|void|ActiveX.IXMLDOMParseError}
     */
    function initValidation($form) {
        var formRequestRules,
            rangeLength = 50;
        formRequestRules = {
            req_name: {
                required: true,
                rangelength: [2, rangeLength]
            },
            req_email: {
                required: true,
                email: true,
                maxlength: 100,
                isValidEmailAddress: true
            },
            req_phone: {
                required: true,
                phoneformat: false,
                minlength: 6,
                maxlength: 15
            },
            req_text: {
                required: true,
                minlength: 5
            }
        };

        FormExt = new RequestFormExtended($form.find('#form_ext'));
        return $form.validate({
            rules: $.extend(formRequestRules, FormExt.getValidator()),
            errorPlacement: function (error, element) {
                error.appendTo($(element).closest('fieldset'));
                scrollToElement(element);
            },
            submitHandler: preSaveRequest,
            invalidHandler: function (form, validator) {
                reportGA(form, validator);
                validator.showErrors();
            }
        });
    }

    /**
     * Validates request form data in a company/headquarter card
     *
     * @param {object} form
     * @param {object} validator
     */
    function reportGA(form, validator) {
        var GaErrorstring,
            aFieldHasBeenFocused,
            fieldName,
            invalid;

        invalid = [];
        fieldName = '';
        aFieldHasBeenFocused = false;
        for (fieldName in validator.invalid) {
            if (validator.invalid[fieldName] !== true) {
                if (!aFieldHasBeenFocused) {
                    scrollToElement('[name=\'' + fieldName + '\']');
                    aFieldHasBeenFocused = true;
                }
                invalid.push(fieldName);
            }
        }

        // Marks in GoogleAnalytics the form errors behaviour
        GaErrorstring = 'device:' + App.device;
        GaErrorstring += '-useragent:' + window.navigator.userAgent;
        GaErrorstring += '-invalid:' + invalid.join('-');

        // window.gaqTrackEvent('Errors', 'CompanyCardRequest', GaErrorstring);
        window.gaTrackListRequestFormInvalidInputs(App.pageVar.comId, GaErrorstring, invalid.join(','));

        // If only 'pop_id' is invalid. Has 'GaErrorstring' created but stills submit form.
        if (invalid.length === 1 && ($.inArray('pop_id', invalid) !== -1)) {
            preSaveRequest();
        }

    }

    /**
     * Executes events before saving request
     */
    function preSaveRequest() {
        window.App.geoLocationManager.checkGeoIpRequest().then(function (response) {
            if (response.success && window.App.geoLocationManager.isAllowedToMakeRequests(response.message) === false) {
                if (document.getElementById('out_of_country') === null) {
                    window.App.geoLocationManager.setGeoIpLayer(response);
                    return;
                }
            }
            if (modal.isVisible) {
                saveRequest($form);
            } else {
                RequestStorage.saveForm($form);
                showRequestForm();
            }
        });
    }

    /**
     * Sends request to php and saves it. Return brings user to next step
     *
     * @param {object} form Extended form data to save.
     */
    function saveRequest(form) {
        var $currentForm = $form,
            aFormExt,
            iOfc = $currentForm.find('#off_id').val(),
            time = $currentForm.find('#appointment_time option:selected').val(),
            date = $currentForm.find('#appointment_date').val(),
            appointmentType = $currentForm.find('#appointment_type').val(),
            data,
            disableDialog = App.isSmartphone(),
            prefixInput = $currentForm.find('#js_visible_signup_prefix').val(),
            phoneInput = $currentForm.find('#req_phone').val();
        // Upates extended data
        aFormExt = FormExt.getElements();
        $currentForm.find('#req_phone').val(prefixInput + phoneInput);
        RequestStorage.saveForm($currentForm);
        data = $currentForm.serialize() + '&form_ext=' + encodeURIComponent(JSON.stringify(aFormExt));

        if (time && date && appointmentType) {
            data = data +
                '&appointment_time=' + time +
                '&appointment_date=' + date +
                '&appointment_type=' + appointmentType;
        }

        // Track params
        data = data + '&pageType=' + encodeURIComponent('list_' + window.tmhAn.listingProperties.listType) +
            '&pageReferrer=' + encodeURIComponent(typeof document.referrer !== 'undefined' ? document.referrer : 'no_referrer') +
            '&pageUrl=' + encodeURIComponent(document.location.href);

        modal.showLoading();

        let params = new URLSearchParams(window.location.href);
        let sourceType = params.get('req_source_type');
        let service = params.get('service');

        // Track sending form to server
        window.gaTrackListRequestFormSend(App.pageVar.comId);

        // Sends the form and extended form data
        $.ajax({
            type: 'POST',
            url: '/front/request/request?com=' + App.pageVar.comId +
                '&ae2check=' + App.pageVar.ae2check +
                '&proximityCheck=' + App.pageVar.proximityCheck +
                '&sourceType=' + sourceType +
                '&service=' + service,
            data: data,
            dataType: 'json',
            error: function () {
                modal.remove();
            },
            success: function (requestResponse) {
                var populationTemplate,
                    messages,
                    params;

                $(document).off('click', '#js_submit_ae2check, .jq_submit_always')
                    .on('click', '#js_submit_ae2check, .jq_submit_always', function (event) {
                        event.preventDefault();
                        event.stopPropagation();
                        preSaveRequest();
                    });

                $form.find('#js_check_autocomplete').hide();

                switch (requestResponse.status) {
                    case 3:
                        if (requestResponse.redirect) {
                            window.location.href = requestResponse.redirect;
                        } else {
                            window.createGoal(requestResponse.message);
                        }
                        break;
                    case 2:
                        // Product case, redirects to products exit
                        window.location.href = requestResponse.redirect;
                        break;
                    case 1:
                        RequestStorage.saveForm($form);
                        if (conf.appEnvDomain === '.'
                            && requestResponse.transactionData !== null
                            && requestResponse.trackingData !== null
                            && ABOGADOS_PROJECT_IDS.includes(conf.project.projectId)
                        ) {
                            window.trackAllTransactions(
                                requestResponse.transactionData,
                                requestResponse.trackingData,
                                () => {
                                    if (iOfc > 0) {
                                        params = {
                                            req: requestResponse.request,
                                            ofc: iOfc,
                                            com: App.pageVar.comId
                                        };
                                        window.location.href = '/front/request/request_end?' + $.param(params);
                                    }
                                }
                            );

                            if (iOfc > 0) {
                                break;
                            }
                        }
                        // Correct next step
                        if (iOfc > 0) {
                            params = {
                                req: requestResponse.request,
                                ofc: iOfc,
                                com: App.pageVar.comId
                            };
                            window.location.href = '/front/request/request_end?' + $.param(params);
                        } else {
                            getStep2(requestResponse.request);
                        }
                        break;
                    case -1:
                        modal.insert(requestResponse.message)
                            .then(function (modalContent) {
                                $(modalContent).find('button').on('click', function () {
                                    modal.remove();
                                });
                                window.gaqTrackEvent('Errors', 'RequestForm', 'LimitExceeded');
                            });
                        break;
                    case -2:
                        modal.hideLoading().then(function (modalContent) {
                            $('#errorProv').hide();

                            messages = $.parseJSON(requestResponse.message);

                            $('#list_link').one('click', function () {
                                document.location.href = requestResponse.redirect;
                            });
                            $('#list_link_txt').html(messages.label);
                            $('#js_error_prov_ttl').html(messages.title);
                            $('#js_error_prov_txt').html(messages.text);

                            $('#errorProv').show();
                            $(modalContent).find('.js_content').hide();
                            modal.setTitle(null);

                            // Forces not to check ae2 next time.
                            App.pageVar.ae2check = 0;
                            // Forces not to check proximity to headquarter
                            App.pageVar.proximityCheck = 0;

                            if (disableDialog) {
                                window.location.href = '#errorProv';
                            }

                            // Error case: not in same province (offer&product only)
                            if ($('#off_id').val()) {
                                window.gaqTrackEvent('Errors', 'IncorrectProvinceOffer', $('#off_id').val());
                            } else if ($('#prd_id').val()) {
                                window.gaqTrackEvent('Errors', 'IncorrectProvinceProduct', $('#prd_id').val());
                            }
                        });
                        break;
                    case -3:
                        modal.hideLoading().then(function (modalContent) {
                            $form = $(modalContent).find('#request_form_v2');
                            $('#errorProv').hide();
                            initForm($form);
                            requestValidator.showErrors({req_phone: requestResponse.message});
                            window.gaqTrackEvent('Errors', 'RequestForm', 'Invalid phone');
                        });
                        break;
                    case -4:
                        modal.hideLoading().then(function (modalContent) {
                            $form = $(modalContent).find('#request_form_v2');
                            $('#errorProv').hide();
                            initForm($form);
                            requestValidator.showErrors({population_autocomplete: requestResponse.message});
                            window.gaqTrackEvent(
                                'Errors',
                                'RequestForm',
                                'Invalid population: ' + $form.find('[name="population_autocomplete"]').val()
                            );
                        });
                        break;
                    case -5:
                        modal.hideLoading().then(function (modalContent) {
                            $form = $(modalContent).find('#request_form_v2');
                            $('#errorProv').hide();
                            initForm($form);
                            requestValidator.showErrors({req_text: requestResponse.message});
                            window.gaqTrackEvent(
                                'Errors',
                                'RequestForm',
                                'Repeated request'
                            );
                        });
                        break;
                    case -6:
                        modal.hideLoading().then(function (modalContent) {
                            $form = $(modalContent).find('#request_form_v2');
                            $form.find('#errorProv').hide();

                            $('#list_link').click(function () {
                                document.location.href = requestResponse.redirect;
                            });

                            messages = $.parseJSON(requestResponse.message);

                            $('#list_link_txt').html(messages.label);
                            $('#js_error_prov_ttl').html(messages.title);
                            $('#js_error_prov_txt').html(messages.text);

                            $('#errorProv').show().removeClass('hide');
                            $(modalContent).find('.js_content').hide();
                            modal.setTitle(null);

                            // Forces not to check proximity to headquarter
                            App.pageVar.proximityCheck = 0;

                            window.gaqTrackEvent(
                                'Errors',
                                'RequestForm',
                                'Distance exceeded'
                            );
                        });
                        break;
                    case -7:
                        modal.hideLoading().then(function (modalContent) {
                            $form = $(modalContent).find('#request_form_v2');
                            $('#errorProv').hide();

                            // Returns populations in the format of autocomplete
                            populationTemplate = $(requestResponse.message).html();
                            $(modalContent).find('.js_content').hide();
                            $('#js_check_autocomplete').html(populationTemplate).show().removeClass('hide');
                            modal.setTitle(null);

                            if (disableDialog) {
                                location.href = '#frm-request';
                            }

                        });
                        break;
                };

                if (conf.project.isProdDomain) {
                    // eslint-disable-next-line no-undef
                    fbq('track', 'Contact');
                }
            }
        });
    }

    /**
     * Executes redirection
     *
     * @param {number} requestId
     */
    function redirectToRequestEnd(requestId) {
        var params = {req: requestId, com: App.pageVar.comId};
        window.location.href = '/front/request/request_end?' + $.param(params);
    }

    /**
     * Final step for requests.
     *
     * @param {integer} requestId
     */
    function requestEnd(requestId) {
        redirectToRequestEnd(requestId);
    }

    /**
     * Changes a form element to its error format. Element, its error image and its
     * anchor to the error
     *
     * @param {object}  form
     * @param {integer} requestId
     */
    function sendRequest(form, requestId) {
        var data;

        modal.showLoading();

        data = $(form).serialize();

        // Track params
        data = data + '&pageType=' + encodeURIComponent('list_' + window.tmhAn.listingProperties.listType) +
            '&pageReferrer=' + encodeURIComponent(typeof document.referrer !== 'undefined' ? document.referrer : 'no_referrer') +
            '&pageUrl=' + encodeURIComponent(document.location.href);

        // In Mobile the loading appears over the step 2 to avoid that will be
        // focus in unsuscribe field or in another place
        $.ajax({
            type: 'POST',
            url: '/front/request/request_step',
            data: data,
            success: function (response) {
                if (conf.appEnvDomain === '.'
                    && response.transactionData.length !== null
                    && response.trackingData !== null
                    && ABOGADOS_PROJECT_IDS.includes(conf.project.projectId)
                ) {
                    window.trackAllTransactions(
                        response.transactionData,
                        response.trackingData,
                        () => {
                            requestEnd(requestId);
                        }
                    );
                    return;
                }
                requestEnd(requestId);
            }
        });
    }

    /**
     * Gets second step of request circuit
     *
     * @param {Number} id Request id
     */
    function getStep2(id) {
        modal.showLoading();
        $.getJSON('/front/request/request_step', {com: App.pageVar.comId, req: id}).done(function (response) {
            switch (response.message) {
                case 'direct_with_service':
                    requestEnd(id);
                    return;
                case 'saved':
                    requestEnd(id);
                    return;

                default:
                    modal.insert(response.message, false)
                        .then(function (modalContent) {
                            var url = window.location.search,
                                urlParametro = new URLSearchParams(url),
                                service = urlParametro.get("service");
                            initStep2Form($(modalContent).find('#form_step2'));
                            namespace.module.autoComplete($(modalContent).find('#form_step2'));
                            $(modalContent).find('#form_step2').validate({
                                rules: {
                                    sev_chk: {
                                        required: true
                                    },
                                    r0_c0_f0_tcountry_p1: {
                                        required: true
                                    },
                                    r0_c1_f0_tcountry_p1: {
                                        required: true
                                    }
                                },
                                errorPlacement: function (error, element) {
                                    if (element.attr('name') === 'sev_chk') {
                                        error.insertAfter('#service_list');
                                        scrollToElement('#service_list');
                                    } else {
                                        error.insertAfter(element);
                                        scrollToElement(element);
                                    }

                                },
                                highlight: function (element) {
                                    if ($(element).attr('name') === 'sev_chk') {
                                        $('#service_list').removeClass('frm-error-ok');
                                        $('#service_list').addClass('frm-error');
                                        scrollToElement('#service_list');
                                    } else {
                                        scrollToElement(element);
                                    }
                                },
                                unhighlight: function (element) {
                                    if ($(element).attr('name') === 'sev_chk') {
                                        $('#service_list').removeClass('frm-error');
                                        $('#service_list').addClass('frm-error-ok');
                                    }
                                },
                                submitHandler: function (form) {
                                    $(form).find('#submit_button').attr('disabled', 'disabled');
                                    // Form extended. Replace select option text to value.
                                    $(form).find('select').each(function (index, element) {
                                        var optionSelected = $(element).find('option:selected');
                                        if ($(element).hasClass('jq_date_month') && optionSelected.val() === 0) {
                                            $(element).remove();
                                        } else {
                                            optionSelected.val(optionSelected.text().trim());
                                        }
                                    });

                                    $(form).find('input[id^=sev_]:checked').val();
                                    sendRequest(form, id);
                                }
                            });
                            if (service != null){
                                $('#sev_'+service).click();
                            }

                            $('#js_all_services').on('click', function () {
                                $('.js_preferent').toggle();
                                $(this).hide();
                            });
                        });
            }

        });
    }

    /**
     * Init Step 2 events
     * @param {Object} $form
     */
    function initStep2Form($form) {
        if ($form.data('sensitive')) {
            $(document).on('click', '.jq_sev', function () {
                $('.js_loading2').show();
                $('.js_other_companys').hide();
                $.ajax({
                    type: 'GET',
                    url: '/front/request/get_similar_companies?' + 'req=' + $('#req').val() + '&sev=' + this.value,
                    success: function (data) {
                        data = $.parseJSON(data);
                        if (data.error === false) {
                            $('#company_names').html(data.sMsg);
                        }
                        $('.js_other_companys').show();
                        $('.js_loading2').hide();
                    }
                });

            });
        }
    }

    /**
     * Starts events for form
     *
     * @param {object} $form
     * @param {bool} preventAutoComplete
     */
    function initForm($form, preventAutoComplete) {
        if (typeof App.pageVar.offerId !== 'undefined' && App.pageVar.offerId !== 0) {
            $('#off_id').val(App.pageVar.offerId);
        }

        // Sets request form headquarter
        assignHeadquarter(App.pageVar.comId, App.pageVar.pop_id, App.pageVar.ae2_id);

        if (!preventAutoComplete) {
            namespace.module.autoComplete($form);
        }
        // Initializes datepickers for extended forms.
        initializeDatepickers($form);

        // Initializes validation.
        requestValidator = initValidation($form);

        $.get('/profile/get_user_data_appointment')
            .done(function getCurrentUser(response) {
                $('#req_name').val(response.data.name);
                $('#req_email').val(response.data.email);
                $('#req_phone').val(response.data.phone);
                $('#req_text').val('');

                var selector = document.getElementsByName('population_autocomplete');
                $(selector).val('');
                phoneInputPrefixes(response.data.phone);
            })
            .fail(function () {
                phoneInputPrefixes();
            });
    }

    $(document).on('ready', function () {
        var $divSteps = $('#div_steps');
        // Initializes form when it is in DOM.
        if ($divSteps.length === 1) {
            $form = $divSteps.find('#request_form_v2');
            initForm($form, true);
        }

        $('[data-source-type]').on('click', function () {
            var parameters = {};
            parameters.sourceType = $(this).data('source-type');
            $.get('/front/request/set_source_type_from_request', parameters);
        });
        $('[data-service]').on('click', function () {
            var parameters = {};
            parameters.service = $(this).data('service');
            $.get('/front/request/set_service_from_request', parameters);
        });
    });

    /**
     * Init phone input prefixes
     */
    function phoneInputPrefixes(phone = '') {
        var countryId = conf.project.projectCountryId,
            countryCode = conf.project.projectCountryCode,
            initCountry = 'es',
            hiddenPrefixInput = document.getElementById('js_invisible_signup_prefix'),
            prefixInput = document.getElementById('js_visible_signup_prefix'),
            countryData = window.intlTelInputGlobals.getCountryData();

        if (countryCode.length > 0) {
            initCountry = countryCode;
        }

        if (phone.indexOf(' ') !== -1) {
            var phonePrefix = phone.substring(1, phone.indexOf(' ')),
                phoneValue = phone.substring(phone.indexOf(' ') + 1);

            initCountry = countryData.find(o => o.dialCode === phonePrefix)['iso2'];
            $('#req_phone').val(phoneValue);
        }

        var iti = window.intlTelInput(hiddenPrefixInput, {
            preferredCountries: ['es', 'fr', 'it', 'pt', 'br', 'cl', 'mx', 'ar', 'co' ],
            initialCountry: initCountry
        });

        prefixInput.value = '+' + iti.getSelectedCountryData().dialCode + ' ';

        iti.promise.then(function () {
            hiddenPrefixInput.addEventListener('countrychange', function() {
                prefixInput.value = '+' + iti.getSelectedCountryData().dialCode + ' ';
            });
        });

    }

}(jQuery, window.App, window.Namespace, document, PubSub, configurations));
